import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { initAnalytics } from './analytics';
import reportWebVitals from './reportWebVitals';
import './fonts/Nexa/NexaBold.otf';

const ELITEALARMS_URL = 'http://elitealarms.com/products/app';

// Routes that already redirect somewhere of their own in App.js.
const PASSTHROUGH_PATHS = ['/manuals/installer', '/sim'];

const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

if (PASSTHROUGH_PATHS.includes(currentPath)) {
  initAnalytics();

  ReactDOM.render(
    <React.Fragment>
      <App />
    </React.Fragment>,
    document.getElementById('root')
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
} else {
  // replace() so the back button doesn't bounce straight back here.
  window.location.replace(ELITEALARMS_URL);
}
